import React, { useRef } from 'react';
import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import Container from '../../components/Container';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import { useIntl } from 'gatsby-plugin-intl';
import StockTradingBanner from '../../components/StockTradingBanner';
import FormBand from '../../svgs/banner-band-flipped.svg';
import StockTradingStocksCards from '../../components/StockTradingStocksCards';
import WhatYouGet from '../../components/StockTradingWhatYouGet';
import { OtherInvestmentOptions } from '../../components/StockTradingOtherInvestmentOptions';
import StockTradingBottomBanner from '../../components/StockTradingBottomBanner';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';
import InvestmentOptions from '../../components/InvestmentOptions';
import Blank from '../../components/Blank';
// 【标题】
const Title = ({ title, lineHeight }) => {
  return (
    <div
      css={css`
        color: #000000;
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        ${Tablet} {
          font-size: 36px;
          font-weight: 500;
          line-height: 1.33;
        }
        ${Desktop} {
          font-size: 36px;
          font-weight: 500;
          line-height: 0.92;
        }
      `}
    >
      {title}
    </div>
  );
};

const InvestIn = ({ picFluid = '', name }) => {
  const intl = useIntl();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        ${Tablet} {
          display: flex;
          flex-direction: column-reverse;
          align-items: center;
        }
        ${Desktop} {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}
    >
      <div
        css={css`
          text-align: center;
          ${Tablet} {
            text-align: center;
          }
          ${Desktop} {
            text-align: left;
            width: 516px;
            // margin-right: 64px;
          }
        `}
      >
        <Title
          title={intl.formatMessage({
            id: `individuals.stock-trading.invest-in-${name}.title`,
          })}
          lineHeight
        />
        <div
          css={css`
            font-weight: normal;
            font-size: 14px;
            line-height: 1.71;
            margin-top: 10px;
            ${Tablet} {
              font-size: 18px;
              line-height: 1.11;
              margin-top: 5px;
            }
            ${Desktop} {
              font-size: 24px;
              line-height: 1.38;
              margin-top: 30px;
            }
          `}
        >
          {intl.formatMessage({
            id: `individuals.stock-trading.invest-in-${name}.description`,
          })}
        </div>
      </div>
      {/* 图片 */}
      <div>
        <Img
          // fluid={data[`SignUP`].childImageSharp.fluid}
          fluid={picFluid}
          imgStyle={{ objectFit: 'fill' }}
          fadeIn={false}
          loading='eager'
          css={css`
            position: absolute;
            width: 347px;
            // transform: translate(-189px, 12px);
            ${Tablet} {
              width: 700px;
              // height: 340px;
              // transform: translate(-267px, 165px);
            }
            ${Desktop} {
              // height: 397px;
              width: 700px;
              // right: 0;
              // transform: translate(-364px, -39px);
            }
          `}
        />
      </div>

      {/* <img
        src={pic}
        css={css`
          ${Desktop} {
            height: 397px;
            width: 696px;
          }
        `}
      /> */}
    </div>
  );
};

// 【渐变背景】
const GradientBackground = ({ to = 'top', marginTop = [0, 0, 0] }) => {
  return (
    <div
      css={css`
        // transform: rotate(-180deg);
        background-image: linear-gradient(
          to ${to},
          rgba(242, 242, 242, 0),
          #f2f2f2
        );
        width: 100%;
        height: 230px;
        margin-top: ${marginTop[0]}px;
        ${Tablet} {
          height: 305px;
          margin-top: ${marginTop[1]}px;
        }
        ${Desktop} {
          height: 353px;
          margin-top: ${marginTop[2]}px;
        }
      `}
    ></div>
  );
};

const StockTradingPage = () => {
  const intl = useIntl();
  const signUpBottomBannerRef = useRef();
  const data = useStaticQuery(graphql`
    query {
      InvestInFunds: file(
        relativePath: { eq: "stock-trading/Invest-in-Funds.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      InvestInStocks: file(
        relativePath: { eq: "stock-trading/Invest-in-Stocks.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);

  return (
    <Layout footerForm footerBand={false} footerBlank>
      <SEO
        title={intl.formatMessage({
          id: 'individuals.stock-trading.SEO.title',
        })}
        description={intl.formatMessage({
          id: 'individuals.stock-trading.SEO.description',
        })}
        keywords={intl.formatMessage({
          id: 'individuals.stock-trading.SEO.keywords',
        })}
      />
      {/* 【banner】 */}
      <StockTradingBanner></StockTradingBanner>
      <Container
        css={css`
          margin-top: 100px;
          ${Tablet} {
            margin-top: 100px;
          }
          ${Desktop} {
            padding: 0;
            margin-top: 6px;
          }
        `}
      >
        {/* 【banner下的小字】 */}
        <div
          css={css`
            color: #cccccc;
            font-weight: normal;
            display: none;
            ${Tablet} {
              display: none;
            }
            ${Desktop} {
              display: block;
              line-height: 1.5;
              margin-bottom: 52px;
              font-size: 12px;
            }
          `}
        >
          {intl.formatMessage({ id: 'individuals.stock-trading.attention' })}
        </div>
        {/* 【Invest In】模块 */}
        <InvestIn
          name='stocks'
          picFluid={data[`InvestInStocks`].childImageSharp.fluid}
        ></InvestIn>
        {/* 【空白高度】 */}
        <Blank height={[50, 50, 39]} />
        <InvestIn
          name='funds'
          picFluid={data[`InvestInFunds`].childImageSharp.fluid}
        ></InvestIn>
      </Container>
      {/* 渐变背景 */}
      <GradientBackground
        to='bottom'
        marginTop={[69, -23, 40]}
      ></GradientBackground>
      {/* 【三种股票策略卡片】 */}
      <div
        css={css`
          margin-top: -197px;
          width: 100%;
          padding: 0;
          ${Tablet} {
            margin-top: -175px;
            padding: 0 30px;
            max-width: 768px;
          }
          ${Desktop} {
            // margin-top: -209px;
            max-width: 1200px;
            padding: 0;
          }
        `}
      >
        <StockTradingStocksCards
          bottomRef={signUpBottomBannerRef}
        ></StockTradingStocksCards>
      </div>
      <Container
        css={css`
          // margin-top: -186px;
          ${Tablet} {
            padding: 0 30px;
            // margin-top: -132px;
          }
          ${Desktop} {
            padding: 0;
            // transform: translateY(-209px);
            // margin-top: -209px;
          }
        `}
      >
        {/* 【三大优势】 */}
        <div
          css={css`
            margin-top: 100px;
            ${Tablet} {
              margin-top: 150px;
            }
            ${Desktop} {
              margin-top: 132px;
            }
          `}
        >
          <Title
            title={intl.formatMessage({
              id: `individuals.stock-trading.what-you-get`,
            })}
          ></Title>
          <Blank height={[20, 20, 50]} />
          <WhatYouGet advantages={['quotes', 'currency-exchange', 'support']} />
        </div>
      </Container>
      <Blank height={[100, 156, 150]}></Blank>
      {/* 【其他组合卡片入口】 */}
      <Container
        css={css`
          ${Tablet} {
          }
          ${Desktop} {
            padding: 0;
          }
        `}
      >
        <Title
          title={intl.formatMessage({
            id: `individuals.investment-options.other-title`,
          })}
        ></Title>
        <Blank height={[10, 40, 48]}></Blank>
      </Container>
      <div
        css={css`
          width: 100%;
          // padding-left: 27px;
          ${Tablet} {
            // padding-left: 30px;
            max-width: 970px;
          }
          ${Desktop} {
            padding-left: 117px;
            max-width: 1440px;
          }
        `}
      >
        <InvestmentOptions doNotShow='StockTrading' />
      </div>
      {/* 【渐变背景】- 仅IPAD端、MOBILE端 */}
      <div
        css={css`
          width: 100%;
          height: 146px;
          margin-top: -242px;
          background-image: linear-gradient(
            to bottom,
            rgba(242, 242, 242, 0),
            #f2f2f2
          );
          ${Tablet} {
            display: block;
            height: 305px;
            margin-top: -431px;
          }
          ${Desktop} {
            display: none;
          }
        `}
      ></div>
      <Blank height={[96, 226, 100]}></Blank>
      {/* 该div是页面内容结束的标记，用于点击按钮【立即注册】后页面滑动到【底部注册】 */}
      <div ref={signUpBottomBannerRef}></div>
    </Layout>
  );
};

export default StockTradingPage;
